import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPepiconsPencilDotsX = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 3,
	viewBox: "0 0 15 3",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 1.5C12 1.10218 12.158 0.720644 12.4393 0.43934C12.7206 0.158035 13.1022 0 13.5 0C13.8978 0 14.2794 0.158035 14.5607 0.43934C14.842 0.720644 15 1.10218 15 1.5C15 1.89782 14.842 2.27936 14.5607 2.56066C14.2794 2.84196 13.8978 3 13.5 3C13.1022 3 12.7206 2.84196 12.4393 2.56066C12.158 2.27936 12 1.89782 12 1.5ZM6 1.5C6 1.10218 6.15804 0.720644 6.43934 0.43934C6.72064 0.158035 7.10218 0 7.5 0C7.89783 0 8.27936 0.158035 8.56066 0.43934C8.84196 0.720644 9 1.10218 9 1.5C9 1.89782 8.84196 2.27936 8.56066 2.56066C8.27936 2.84196 7.89783 3 7.5 3C7.10218 3 6.72064 2.84196 6.43934 2.56066C6.15804 2.27936 6 1.89782 6 1.5ZM0 1.5C0 1.10218 0.158035 0.720644 0.43934 0.43934C0.720644 0.158035 1.10218 0 1.5 0C1.89782 0 2.27936 0.158035 2.56066 0.43934C2.84196 0.720644 3 1.10218 3 1.5C3 1.89782 2.84196 2.27936 2.56066 2.56066C2.27936 2.84196 1.89782 3 1.5 3C1.10218 3 0.720644 2.84196 0.43934 2.56066C0.158035 2.27936 0 1.89782 0 1.5Z",
		fill: "#A0A0A0"
	})
});
export default SvgPepiconsPencilDotsX;
